const ApiKeys = {
    BASE_URL: process.env.VUE_APP_BASE_URL
 };
 export default ApiKeys;